import { Collection } from "@authory-packages/core";
import { useState } from "react";
import { AddToCollectionDropdownPanel } from "../AddToCollectionDropdownPanel";
import { V3TertiaryButton } from "../Button";
import { V3TertiaryCTAColor } from "../Button/V3TertiaryCTA.types";
import { CreateUpdateCollectionModal, CreateCollectionHandler } from "../CreateUpdateCollectionModal";
import { V3Dropdown } from "../Dropdown";
import { V3BlueRoundPlus } from "../ReusableStyledComponents/V3BlueRoundPlus";
import { Placement, Strategy } from "@floating-ui/react";

interface AddToCollectionCTAProps {
    collections: Collection[];
    onCollectionClick: (slug: string) => void;
    addBtnColor?: V3TertiaryCTAColor;
    title?: string;
    onCreateCollectionHandler?: CreateCollectionHandler;
    modalDescription?: string;
    placement?: Placement;
    strategy?: Strategy;
    customOffset?: number;
}

export const AddToCollectionCTA = ({
    collections,
    title = "Add to collection",
    onCollectionClick,
    addBtnColor,
    onCreateCollectionHandler,
    modalDescription,
    placement,
    strategy,
    customOffset
}: AddToCollectionCTAProps) => {
    const [createCCModalOpen, setCreateCCModalOpen] = useState(false);

    return (
        <>
            <V3Dropdown
                title={title}
                renderReferenceElement={() => {
                    if (!collections.length) return <></>;

                    return <V3TertiaryButton text={title} icon={<V3BlueRoundPlus />} ctaColor={addBtnColor} />;
                }}
                maxWidth={221}
                renderPopperElement={(open, setDropDownVisible) => {
                    if (!open) return <></>;

                    return (
                        <AddToCollectionDropdownPanel
                            collections={collections}
                            onCreateCollectionClick={() => {
                                setCreateCCModalOpen(true);
                                setDropDownVisible(false);
                            }}
                            onCollectionClick={(slug) => {
                                onCollectionClick(slug);
                                setDropDownVisible(false);
                            }}
                        />
                    );
                }}
                placement={placement}
                strategy={strategy}
                customOffset={customOffset}
            />
            {createCCModalOpen && !!onCreateCollectionHandler && (
                <CreateUpdateCollectionModal
                    modalOpen={createCCModalOpen}
                    setModalOpen={setCreateCCModalOpen}
                    title="Create collection"
                    onSubmit={onCreateCollectionHandler}
                    modalDescription={modalDescription}
                />
            )}
        </>
    );
};
